import React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "assets/css/MiniCalendar.css";
import ChevronLeft from "components/icons/ChevronLeft";
import ChevronRight from "components/icons/ChevronRight";

const MiniCalendar = (props) => {
  const {
    value,
    onChange,
    isFutureDateDisabled = false,
    isPastDateDisabled = false,
    ...others
  } = props;

  // Combine the conditions for disabling dates
  const tileDisabled = ({ date }) => {
    const today = new Date();
    // Remove time part for comparison
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);

    if (isFutureDateDisabled && checkDate > today) return true;
    if (isPastDateDisabled && checkDate < today) return true;
    return false;
  };

  return (
    <div className="flex w-full h-full max-w-full flex-col border rounded-[20px] bg-white px-3 py-4 dark:!border-white/10 dark:!bg-navy-800">
      <Calendar
        onChange={onChange}
        value={value || ""}
        prevLabel={<ChevronLeft />}
        nextLabel={<ChevronRight />}
        tileDisabled={tileDisabled}
        {...others}
      />
    </div>
  );
};

export default MiniCalendar;
